import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  type = 'website',
  image,
  schema
}) => {
  const siteUrl = 'https://ransen.ca';
  const defaultImage = `${siteUrl}/og-image.png`;
  
  const fullTitle = title ? `${title} | RANSEN` : 'Digital Marketing Agency Canada | SEO, PPC, AI Marketing | RANSEN';
  const metaDescription = description || 'RANSEN is Canada\'s leading AI-driven digital marketing agency. We deliver Paid Media, SEO, Social Media Marketing, Video Production, AI Automation, LLMO & AEO services. 500+ projects with 98% client satisfaction.';
  const metaKeywords = keywords || 'digital marketing agency Canada, SEO company, PPC management, social media marketing, AI marketing, video production, LLMO, AEO, web design';
  const canonicalUrl = canonical === '/' ? `${siteUrl}/` : (canonical ? `${siteUrl}${canonical}` : `${siteUrl}/`);
  const ogImage = image || defaultImage;

  // Direct DOM manipulation for canonical URL and meta description as a backup
  useEffect(() => {
    // Remove any existing canonical links
    const existingCanonicals = document.querySelectorAll('link[rel="canonical"]');
    existingCanonicals.forEach(link => link.remove());
    
    // Add the correct canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', metaDescription);
    } else {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      metaDesc.content = metaDescription;
      document.head.appendChild(metaDesc);
    }
    
    return () => {
      // Cleanup on unmount
      const canonicalLink = document.querySelector(`link[href="${canonicalUrl}"]`);
      if (canonicalLink) canonicalLink.remove();
    };
  }, [canonicalUrl, metaDescription]);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Schema.org structured data */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
